
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["pie-demo-common","pie-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Pie__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Pie/index.en.md?type=demo')
};